import BaseApplication from "pages/BaseApplication"
import AssignStaff from "../AssignStaff/index"
import { useEffect, useState } from "react"

import Application from "services/applications/Application.service"
import DisposalDetails from "./DisposalDetails"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const DisposalGuidance = props => {
  console.log("Data", props.appDetails)
  const assignApplicationToOfficer = formData => {
    appService.assignStaff(formData).then(response => {
      if (response.status) {
        alert("Officer successfully assigned")
      } else {
        console.log(response)
      }
    })
  }
  return (
    <BaseApplication
      submit={assignApplicationToOfficer}
      title={"Assign Staff"}
      attachments={props.appDetails.application_attachments}
      formComponent={
        <AssignStaff
          department={props.appDetails.service.department_id}
          appDetails={{
            applicationId: props.appDetails.id,
            assignedBy: loggedInUser.id,
          }}
        />
      }
      appDetails={<DisposalDetails appDetails={props.appDetails} />}
      applicationData={props.appDetails}
    />
  )
}

export default DisposalGuidance
